module.exports = "/_next/static/images/152ae87df2aeb8a79726d99b5a37a883-man-looking-up-smiling-md@3x.jpg";